/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';
import IconBlock from 'component/common/block/icon-block';
import { actions as navigationAction } from '@store/slice/navigation-slice';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { useNavigate } from 'react-router-dom';
import { MOASHELF_PATH } from '@constant/moashelf/route-path';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  position: fixed;
  bottom: 0;
  //padding-bottom: env(safe-area-inset-bottom);
  height: ${size.MOBILE_BOTTOM_HEIGHT};
  justify-content: space-around;
  width: 100%;
  background-color: ${color.GRAY_4};
`;

// bottom 메뉴 동적으로 받을수 있게 업데이트
const BottomTab: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const bottomTabMenu = useTypedSelector((state) => state.rootReducer?.navigationReducer?.moashelf?.mainMenu) ?? null;
  const handleClickHome = () => {
    dispatch(navigationAction.storeMoashelfMainMenu('begin'));
    navigate(MOASHELF_PATH.BEGIN_PATH);
  };
  const handleClickShelf = () => {
    dispatch(navigationAction.storeMoashelfMainMenu('shelf'));
    navigate(MOASHELF_PATH.SHELF_PATH);
  };
  const handleClickSubscription = () => {
    dispatch(navigationAction.storeMoashelfMainMenu('subscription'));
    navigate(MOASHELF_PATH.SUBSCRIPTION_PATH);
  };

  return (
    <Wrapper>
      <IconBlock
        icon='mail'
        design={{
          icon: {
            kind: 'outlined',
            size: 'medium',
          },
          box: {
            width: '70px',
            height: '30px',
            borderRadius: size.BORDER_RADIUS_3,
            backgroundColor: bottomTabMenu === 'shelf' ? color.GRAY_2 : 'none',
          },
        }}
        click={{ handler: handleClickShelf }}
      />
      <IconBlock
        icon='window'
        design={{
          icon: {
            kind: 'outlined',
            size: 'medium',
          },
          box: {
            width: '70px',
            height: '30px',
            borderRadius: size.BORDER_RADIUS_3,
            backgroundColor: bottomTabMenu === 'begin' ? color.GRAY_2 : 'none',
          },
        }}
        click={{ handler: handleClickHome }}
      />
      <IconBlock
        icon='inventory'
        design={{
          icon: {
            kind: 'outlined',
            size: 'medium',
          },
          box: {
            width: '70px',
            height: '30px',
            borderRadius: size.BORDER_RADIUS_3,
            backgroundColor: bottomTabMenu === 'subscription' ? color.GRAY_2 : 'none',
          },
        }}
        click={{ handler: handleClickSubscription }}
      />
    </Wrapper>
  );
};

export default BottomTab;
